export default function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src023959432/src/github.com/GipsyBot/gipsy-webapp/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
// module id = 1106
// module chunks = 0